import { useI18n } from 'vue-i18n'
import type ko from '@/plugins/i18n/locales/ko.json'

export function useI18nTypes() {
  const i18n = useI18n<
    {
      message: typeof ko
    },
    string
  >()

  return i18n
}
